<p-tabView>
  <p-tabPanel header="Notes" icon="pi pi-comment">
    <notes [job]="job" [currentUser]="currentUser"></notes>
  </p-tabPanel>
  <p-tabPanel header="Activity Audit Log" icon="pi pi-history">
    <job-activity-audit [job]="job"></job-activity-audit>
  </p-tabPanel>
</p-tabView> 